import { useGenericPermissions } from '@infuse/iam/permission/queries';
import { searchOrganisationPermissions } from '@infuse/api/iam/organisation';

export const useOrganisationPermissions = () => {
  return useGenericPermissions({
    apiFn: searchOrganisationPermissions,
    queryKeys: ['permissions', 'organisation'],
    onlyEnableWithParentId: true
  });
};
